/**
 * QA-122 (b안) — CMS 콘텐츠 본문 다국어 입력 로케일.
 *
 * ko-KR 이 정본(top-level 필드). 나머지 로케일은 translations 맵에 입력하며,
 * 비우면 스토어프론트가 ko-KR 로 폴백한다. Notice/Product 등 기존 per-locale 컨벤션과 동일.
 */
export const CONTENT_LOCALES = ['ko-KR', 'en-US', 'ja-JP', 'zh-CN'] as const;
export type ContentLocale = (typeof CONTENT_LOCALES)[number];

/** 기본(정본) 로케일 — 이 로케일은 폼 top-level 필드가 정본이며 빈 값 허용 안 함. */
export const BASE_CONTENT_LOCALE: ContentLocale = 'ko-KR';

/** 탭/스위처에 표시하는 로케일 라벨(백오피스 UI 한국어지만 로케일 자체는 자국 표기). */
export const CONTENT_LOCALE_LABEL: Record<ContentLocale, string> = {
  'ko-KR': '한국어',
  'en-US': 'English',
  'ja-JP': '日本語',
  'zh-CN': '中文',
};

/** 정본을 제외한 번역 로케일 목록(en/ja/zh). */
export const TRANSLATION_LOCALES: readonly ContentLocale[] = CONTENT_LOCALES.filter(
  (l) => l !== BASE_CONTENT_LOCALE,
);
